<template>
	<div>
		<h3>
			<q-icon class="icon-fleche"/>
			{{ title }}
		</h3>
		<p>
			Des pétitions citoyennes adressées aux mairies ont émergé dans de nombreuses communes pour réclamer plus de repas végétariens. Trouvez celle qui concerne votre ville ou créez-la sur <a href="https://www.cantineverte.fr" target="_blank" @click="link($event, 'cantine-verte')">www.cantineverte.fr</a>
		</p>

		<p>
			Si vous souhaitez en faire plus, vous pouvez également entrer en contact avec les créateurs et créatrices de pétition sur le site <a href="https://www.cantineverte.fr" target="_blank"  @click="link($event, 'cantine-verte')">cantineverte.fr</a>, ou bien communiquer directement avec nos groupes locaux <a href="https://www.greenpeace.fr/groupes-locaux/carte-groupes-locaux/" target="_blank" @click="link($event, 'groupes-locaux')">ici</a>.
		</p>
	</div>
</template>

<script>
export default {
	name: "ActionCantineverte",
		props: {
		title: String,
	},
	methods: {
		link(e, label) {
			e.preventDefault()
			let href = e.target.href

			this.open(href, label)
		},
		open(href, label) {
			this.$trackEvent("click", "lien externe " + label)
			window.open(href, '_blank')
		}
	},
}
</script>